import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AddDayDetailsFormValues } from "src/models/AddDayDetails.model";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import { AiOutlinePlus } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";

type Props = {
  formikProps: FormikProps<AddDayDetailsFormValues>;
  editorValue?: any;
};

const AddDayDetailsForm = ({
  formikProps,
  editorValue = "",
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col gap-6 p-2">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Add Details</div>
      
      </div>
      <div className="flex flex-col gap-4">
        {/* Notes */}
        <div className=" w-full">
          <ATMHTMLEditor
            key={editorValue}
            label="Notes"
            required
            value={values?.notes}
            placeholder="Write description here...."
            onChange={(newValue: any) => {
              setFieldValue("notes", newValue);
            }}
          />
        </div>
        {/* Example And Script */}
        <div >
          <ATMHTMLEditor
            key={editorValue}
            label="Example And Script"
            required
            value={values?.exampleAndScript}
            placeholder="Write description here...."
            onChange={(newValue: any) => {
              setFieldValue("exampleAndScript", newValue);
            }}
          />
        </div>
       <div>
       <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
          Resources
        </div>
        <div className="mt-1">
          <FieldArray
            name="resources"
            render={({ push, remove }) => (
              <>
                {values?.resources?.map((doc: any, index: any) => {
                  return (
                    <div key={index}>
                      <div className="flex justify-end mt-3">
                        <MdDelete
                          color="#F70913"
                          size={30}
                          className="pl-1 cursor-pointer"
                          onClick={() => {
                            showConfirmationDialog({
                              title: "Heads Up",
                              text: "Are you sure want to Delete this Resources?",
                              icon: "question",
                              showCancelButton: true,
                              next: (result) => {
                                if (result.isConfirmed) {
                                  remove(index);
                                }
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="grid  grid-cols-1 xl:gap-6 gap-4">
                        <div>
                          <ATMTextField
                            name={`resources[${index}].name`}
                            value={values?.resources?.[index]?.name}
                            onChange={(e) =>
                              setFieldValue(
                                `resources[${index}].name`,
                                e.target.value
                              )
                            }
                            label={`Resources ${index + 1}`}
                            placeholder="Enter Resources"
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="flex justify-end my-4">
                  <p
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                    onClick={() =>
                      push({
                        name: "",
                      })
                    }
                  >
                    <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                    Add
                  </p>
                </div>
              </>
            )}
          />
        </div>
       </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddDayDetailsForm;
